import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusesSection() {
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="max-w-5xl mx-auto" data-id="element-14">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B]" data-id="element-16">
              Order Today and Get This Free Bonus
            </h2>
          </motion.div>

          {/* Bonus Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#F8FAFC] rounded-xl border border-[#E2E8F0] overflow-hidden mb-16" data-id="element-17">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-18">
              {/* Book Image */}
              <div className="p-8 lg:p-10 flex items-center justify-center bg-gradient-to-br from-[#F0FDFA] to-[#F8FAFC]" data-id="element-19">
                <motion.div initial={{
                opacity: 0,
                rotate: -3
              }} whileInView={{
                opacity: 1,
                rotate: -2
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 0.2
              }} className="relative" data-id="element-20">
                  <div className="absolute inset-0 bg-black/10 rounded-lg blur-xl transform translate-y-4 translate-x-2" data-id="element-21" />
                  <img src="https://cdn.magicpatterns.com/uploads/9MUG8ymoq3GhpszetRiXKL/ChatGPT_Image_Mar_2,_2026,_06_55_26_PM.png" alt="Weekly Feeding Stability Guide - Free Bonus" className="relative w-full max-w-xs rounded-lg shadow-xl" data-id="element-22" />
                </motion.div>
              </div>

              {/* Description */}
              <div className="p-8 lg:p-10 flex flex-col justify-center" data-id="element-23">
                {/* FREE BONUS Badge */}
                <div className="mb-4" data-id="element-24">
                  <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#0F766E] text-white text-sm font-semibold rounded-full" data-id="element-25">
                    <Gift className="w-4 h-4" data-id="element-26" />
                    FREE BONUS
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-2xl md:text-3xl font-bold text-[#1E293B] mb-2" data-id="element-27">
                  Weekly Feeding Stability Guide
                </h3>
                <p className="text-[#475569] mb-6" data-id="element-28">
                  Structured Planning for Ingredient Rotation and Consistent
                  Portions
                </p>

                {/* Description */}
                <p className="text-[#475569] mb-6 leading-relaxed" data-id="element-29">
                  This companion guide helps you maintain feeding consistency
                  week after week. Plan your ingredient rotations, track portion
                  sizes, and build the stable routine your Frenchie's sensitive
                  belly needs.
                </p>

                {/* Benefits List */}
                <ul className="space-y-3 mb-8" data-id="element-30">
                  <li className="flex items-start gap-3" data-id="element-31">
                    <CheckCircle2 className="w-5 h-5 text-[#0F766E] flex-shrink-0 mt-0.5" data-id="element-32" />
                    <span className="text-[#475569]" data-id="element-33">
                      Weekly meal planning templates to stay organized
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-34">
                    <CheckCircle2 className="w-5 h-5 text-[#0F766E] flex-shrink-0 mt-0.5" data-id="element-35" />
                    <span className="text-[#475569]" data-id="element-36">
                      Ingredient rotation schedules that prevent sensitivities
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-37">
                    <CheckCircle2 className="w-5 h-5 text-[#0F766E] flex-shrink-0 mt-0.5" data-id="element-38" />
                    <span className="text-[#475569]" data-id="element-39">
                      Portion tracking sheets for consistent feeding
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-40">
                    <CheckCircle2 className="w-5 h-5 text-[#0F766E] flex-shrink-0 mt-0.5" data-id="element-41" />
                    <span className="text-[#475569]" data-id="element-42">
                      Designed to work seamlessly with the Smart Feeding System
                    </span>
                  </li>
                </ul>

                {/* Value Callout */}
                <div className="bg-white rounded-lg border border-[#E2E8F0] p-4" data-id="element-43">
                  <p className="text-center" data-id="element-44">
                    <span className="text-[#475569]" data-id="element-45">Value: </span>
                    <span className="text-[#1E293B] font-semibold line-through" data-id="element-46">
                      $27
                    </span>
                    <span className="text-[#0F766E] font-bold text-lg ml-2" data-id="element-47">
                      — Yours FREE today
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Why a Routine Works Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-center mb-8" data-id="element-48">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1E293B]" data-id="element-49">
              Why a Routine Works Better Than Guessing
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-[#F8FAFC] rounded-xl border border-[#E2E8F0] p-8 md:p-12 max-w-3xl mx-auto" data-id="element-50">
            <div className="space-y-6 text-lg text-[#475569] leading-relaxed" data-id="element-51">
              <p data-id="element-52">Your Frenchie's belly thrives on routine.</p>
              <p data-id="element-53">
                When meals keep changing, their body never gets a chance to
                settle.
              </p>
              <p data-id="element-54">
                But when things stay consistent,{' '}
                <span className="font-semibold text-[#1E293B]" data-id="element-55">
                  everything starts to calm down
                </span>
                .
              </p>
              <p data-id="element-56">
                That's why switching brands over and over usually doesn't help —
                it just keeps the cycle going.
              </p>
              <p className="pt-4" data-id="element-57">
                You've probably already noticed how often you're making little
                adjustments.
              </p>
              <p className="text-[#0F766E] font-semibold" data-id="element-58">
                Once you see the pattern, you can finally break it.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}